/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOLeaveEligibility from "./DTOLeaveEligibility";
import LeaveEligibilityPresenter from "./LeaveEligibilityPresenter";
import { useAppSelector } from "../../../../infra/hooks";

import { useTranslation } from "react-i18next";

function LeaveEligibilityController() {
  const { t } = useTranslation();
  const [allLeavesData, setAllLeavesData] = useState([]);
  const isLoading = useAppSelector(
    (state) => state.leaveEligibilitySlice.refreshLeaveEligibility
  );
  
  function callBackFunc(data: any) {
    setAllLeavesData(data);
  }

  return (
    <>
      <DTOLeaveEligibility setLeaveEligibilityData={callBackFunc} />
      <LeaveEligibilityPresenter
        leaveData={allLeavesData}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default LeaveEligibilityController;
